import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';


import { getTotalPartnersTrashed, getPartnerPagedTrashed, findpartnersendotplink, deActivatePartner, adminUser, restoreTrash } from '../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';


import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class partnerListTrashed extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              partnerList: [],
              exportbtndisabled:false,  
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:0,
              offset:0,
              thisExportBtnText:'Export',
              monthList: [{ no: 1, mon: 'Jan' }, { no: 2, mon: 'Feb' }, { no: 3, mon: 'Mar' }, { no: 4, mon: 'Apr' },
            { no: 5, mon: 'May' }, { no: 6, mon: 'Jun' }, { no: 7, mon: 'Jul' }, { no: 8, mon: 'Aug' },
            { no: 9, mon: 'Sep' }, { no: 10, mon: 'Oct' }, { no: 11, mon: 'Nov' }, { no: 12, mon: 'Dec' }],
        };

        
 
    }

 

    componentDidMount() {
        
        let THIS = this;
  
        $(document).on('click', '.restoretrash', function () {
          var trash_id = $(this).data("id");
          THIS.restoretrashit(trash_id);
        });
        
        this.getTotalTrashed('partners');
        this.getListTrashed();

    }


    
    restoretrashit(deact_id = '') {
      if(confirm("Are you sure to restore?")== true) {
              let ins = JSON.stringify({
                  id: deact_id                
              });
              restoreTrash(ins).then((res) => {
                  
                  if (res.status === 1) {
                      
                      NotificationManager.success(res.message);
                      
                      setTimeout(function () {
                          window.location.reload();
                      }, 2000);
                      
                  } else {
                      
                      NotificationManager.error(res.message);
                  }
              });
          }
     }

  


    getTotalTrashed = (vertical, location='') => {


      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalPartnersTrashed(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }  



    handleChangeN = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }    

    filterShow  = async () => {

      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        login_id: login_id,
        role: role,
        location: this.state.location,
        year: this.state.year,
        month: this.state.month,
      });
      getPartnerPagedTrashed(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            partnerList: res.data
            
          });
        } else {
          this.setState({
            partnerList: [],
          });
        }
      });

    }

 

    getListTrashed = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        offset:newOffset
      });

      getPartnerPagedTrashed(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            
            partnerList: res.data
            
          });

        } else {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            partnerList: [],
          });
        }
      });


    }     


  handlePageChange(pageNumber) {

      console.log(`active page is ${pageNumber}`);

      this.setState({activePage: pageNumber});

      //this.getTotal('bw_schools');
      this.getList(pageNumber);


  }       

    render() {

        const { partnerList, exportbtndisabled} = this.state;

        const { eventList, currentPage, PER_PAGE, totalCount, total } = this.state;

        const year = 2019;
        const years = Array.from(new Array(10), (val, index) => index + year);

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Trashed Partner Info</h4>
                                   
                  
                  <div class="table-responsive pt-3">
                   <table id="tablebw">
                      <thead class="thead-dark">
                        <tr>

                          <th>
                            <strong>S.No</strong>
                          </th>
                         
                          <th>
                            <strong>Name</strong>
                          </th>

                           <th>
                            <strong>Email Id</strong>
                          </th>

                          <th>
                            <strong>Type</strong>
                          </th>

                        

                          <th>
                            <strong>Category</strong>
                          </th>
                         
                            <th>
                            <strong>Created on</strong>
                          </th>
                         
                          <th>
                            <strong>Status</strong>
                          </th>

                          <th>
                            <strong>Action</strong>
                          </th>

                        </tr>
                      </thead>
                      <tbody>


                      {partnerList.length>0 && partnerList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {item.s_no}
                          </td>
              
                          <td>
                            {item.name}
                          </td>

                           <td>
                            {item.email_id}
                          </td>

                          <td>
                            {item.user_type}
                          </td>
                          

                        

                          <td>
                            {item.category_name}
                          </td>

                          <td>
                            {item.created_date}
                          </td>

                           
                          
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                                                       
                          <td class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }

                      {partnerList.length==0 && 

                        <tr><td colspan="5">No data</td></tr>

                        
                      }
                       
                      </tbody>
                       
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>


                  </div>
                </div>
              </div>
            </div>
            <NotificationContainer />     
                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default partnerListTrashed;


// WEBPACK FOOTER //
// ./src/components/bewise/trash/partnerList.jsx